module.exports = __webpack_public_path__ + "img/lightGreen.5ee71d50.svg";